module.exports = __webpack_public_path__ + "static/img/3.ed88858.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3.jpg
// module id = lQgp
// module chunks = 21